/* global __DEV__ */
// Must be imported before any rxjs usage so legacy operators (e.g. startWith) get patched onto Observable.prototype
import 'rxjs-compat';
import React from 'react';

//WMCE-455: Reduced muster initialization -- changed path for ebanking
import EBanking from './ebanking';
import App from './components/app';

import './assets/postcss/ebanking.css';

function EBankingDev() {
  return (
    <EBanking>
      <App />
    </EBanking>
  );
}

export default EBankingDev;
